import NumberInput from '../../../components/NumberInput'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loader2 } from 'lucide-react'
import { Button } from '../../../components/ui/button'

export function MacroTargetsEditor({ initialValues, submitting, onSave, onCancel, onClear }) {
  const { t } = useTranslation()
  const [kcal, setKcal] = useState(initialValues?.kcal ?? '')
  const [protein, setProtein] = useState(initialValues?.protein ?? '')
  const [carbs, setCarbs] = useState(initialValues?.carbs ?? '')
  const [fat, setFat] = useState(initialValues?.fat ?? '')

  const handleSave = (e) => {
    e.preventDefault()
    onSave({ kcal, protein, carbs, fat })
  }

  return (
    <form onSubmit={handleSave} className="space-y-3">
      <p className="text-xs uppercase tracking-wide text-muted-foreground font-medium">
        {t('phoenixTracker.meals.targets.title')}
      </p>

      <div>
        <label className="block text-xs text-muted-foreground mb-1">
          {t('phoenixTracker.meals.targets.form.kcal')}
        </label>
        <NumberInput
          inputMode="numeric"
          step="50"
          min="0"
          max="9999"
          value={kcal}
          onChange={(e) => setKcal(e.target.value)}
          placeholder="0"
          dir="ltr"
          className="h-11 w-full px-3 rounded-lg border border-input bg-background text-foreground text-base sm:text-sm font-mono"
        />
      </div>

      <div className="grid grid-cols-3 gap-2">
        <div>
          <label className="block text-[10px] text-muted-foreground mb-1">
            {t('phoenixTracker.meals.targets.form.protein')}
          </label>
          <NumberInput
            inputMode="decimal"
            step="1"
            min="0"
            max="999"
            value={protein}
            onChange={(e) => setProtein(e.target.value)}
            placeholder="0"
            dir="ltr"
            className="h-10 w-full px-2 rounded-md border border-input bg-background text-foreground text-sm font-mono text-center"
          />
        </div>
        <div>
          <label className="block text-[10px] text-muted-foreground mb-1">
            {t('phoenixTracker.meals.targets.form.carbs')}
          </label>
          <NumberInput
            inputMode="decimal"
            step="1"
            min="0"
            max="999"
            value={carbs}
            onChange={(e) => setCarbs(e.target.value)}
            placeholder="0"
            dir="ltr"
            className="h-10 w-full px-2 rounded-md border border-input bg-background text-foreground text-sm font-mono text-center"
          />
        </div>
        <div>
          <label className="block text-[10px] text-muted-foreground mb-1">
            {t('phoenixTracker.meals.targets.form.fat')}
          </label>
          <NumberInput
            inputMode="decimal"
            step="1"
            min="0"
            max="999"
            value={fat}
            onChange={(e) => setFat(e.target.value)}
            placeholder="0"
            dir="ltr"
            className="h-10 w-full px-2 rounded-md border border-input bg-background text-foreground text-sm font-mono text-center"
          />
        </div>
      </div>

      <div className="flex gap-2">
        {onCancel && (
          <Button type="button" variant="outline" onClick={onCancel} className="flex-1">
            {t('phoenixTracker.meals.form.cancel')}
          </Button>
        )}
        <Button
          type="submit"
          disabled={submitting}
          className="flex-1 bg-app-primary-500 hover:bg-app-primary-600 text-white"
        >
          {submitting ? (
            <><Loader2 className="w-4 h-4 animate-spin me-2" /> {t('phoenixTracker.meals.form.saving')}</>
          ) : (
            t('phoenixTracker.meals.targets.form.save')
          )}
        </Button>
      </div>

      {onClear && (
        <button
          type="button"
          onClick={onClear}
          disabled={submitting}
          className="w-full text-xs text-muted-foreground hover:text-red-500 py-1 disabled:opacity-50"
        >
          {t('phoenixTracker.meals.targets.form.clear')}
        </button>
      )}
    </form>
  )
}
